import { useEffect, useState } from 'react';
import { useWindowDimensions } from 'react-native';

export type Orientation = 'portrait' | 'landscape';

/**
 * Hook to track device orientation changes
 * @returns current orientation and whether it's changed from initial
 */
export const useOrientation = () => {
	const { width, height } = useWindowDimensions();
	const [orientation, setOrientation] = useState<Orientation>(
		width > height ? 'landscape' : 'portrait',
	);
	const [hasChanged, setHasChanged] = useState(false);

	useEffect(() => {
		const newOrientation: Orientation = width > height ? 'landscape' : 'portrait';

		if (newOrientation !== orientation) {
			setOrientation(newOrientation);
			setHasChanged(true);
		}
	}, [width, height, orientation]);

	return {
		orientation,
		isLandscape: orientation === 'landscape',
		isPortrait: orientation === 'portrait',
		hasChanged,
		dimensions: { width, height },
	};
};
